import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
} from 'class-validator';
import { CountryCodes } from '../types/CountryCodes'; // NOTE: circular dependency
import { validateZipCode } from '../utils';

export function IsZipCode(validationOptions?: ValidationOptions) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'zipCodeValidator',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: string, args: ValidationArguments) {
          const obj = args.object as { country: CountryCodes };
          if (!obj?.country) return false;
          return validateZipCode({
            country: obj.country,
            zipCode: value,
          }).isFullAndValid;
        },
        defaultMessage(args: ValidationArguments) {
          return `${args.property} is not a valid zip code`;
        },
      },
    });
  };
}
